import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, PageEvent } from '@angular/material';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-campana-admin-table',
  templateUrl: './campana-admin-table.component.html',
  styleUrls: ['./campana-admin-table.component.scss']
})
export class CampanaAdminTableComponent {

  @Input() dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  @Input() resultsLength: number = 0;
  @Input() pageSize: number = 10;
  @Input() selectedRow: any = null;

  @Output() editCampana = new EventEmitter<{ element: any, title: string }>();
  @Output() createForContrata = new EventEmitter<any>();
  @Output() editFilterClientes = new EventEmitter<any>();
  @Output() exportList = new EventEmitter<any>();
  @Output() exportListClientes = new EventEmitter<any>();
  @Output() deleteCampana = new EventEmitter<any>();
  @Output() rowClicked = new EventEmitter<any>();
  @Output() pageChanged = new EventEmitter<PageEvent>();
  @Output() openFileInput = new EventEmitter<any>();

  @ViewChild('campanapaginator') campanapaginator: MatPaginator;

  campanaColumns: string[] = ['NOMBREEJE', 'NOMBRE', 'MEDIO', 'ESTADO', 'CREACION', 'VIGENCIAINICIAL', 'VIGENCIAFINAL', 'CANTCLIENT', 'FECHAUPDATE', 'ACCION'];

  constructor(public localSave: LocalSaveService) {}

  isSelected(row: any): boolean {
    return this.selectedRow === row;
  }

  onRowClick(row: any) {
    this.rowClicked.emit(row);
  }

  onEditCampana(element: any, title: string) {
    this.editCampana.emit({ element, title });
  }

  onCreateForContrata(element: any) {
    this.createForContrata.emit(element);
  }

  onEditFilterClientes(element: any) {
    this.editFilterClientes.emit(element);
  }

  onExportList(element: any) {
    this.exportList.emit(element);
  }

  onExportListClientes(element: any) {
    this.exportListClientes.emit(element);
  }

  onDeleteCampana(element: any) {
    this.deleteCampana.emit(element);
  }

  onPageChange(event: PageEvent) {
    this.pageChanged.emit(event);
  }

  onOpenFileInput(element: any) {
    this.openFileInput.emit(element);
  }
}
